import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { CurrentUser } from './../../models/current-user';
import { AccountSettings } from './../../models/account-settings';
import { ApiKey } from './../../models/api-key';

import { AuthHttp, JwtHelper } from 'angular2-jwt';
import { ApiService } from '../../root-services/api.service';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { UserLevel } from '../../models/user-levels';
import { Permission } from '../../models/permission';

@Injectable()

export class CurrentUserService {
  public _current: CurrentUser;
  private _userObservable: ReplaySubject<CurrentUser>;

  constructor(private api: ApiService, private http: AuthHttp) { }

  public getUserData(): Observable<CurrentUser> {
    if (!this._userObservable) {
      this._userObservable = new ReplaySubject(1);
      this.refreshUserData();
    }
    return this._userObservable;
  }

  public refreshUserData(): void {
    if (!this._userObservable) {
      // Cannot refresh if nobody is observing it yet
      return;
    }
    this.api.get('/identity').subscribe((response: Response) => {
      const currentUser = response.json() as CurrentUser;
      
      this._userObservable.next(currentUser);
    });
  }

  public getAccountSettings(): Observable<AccountSettings> {
    return this.api.get('/me/settings')
                   .map((response: Response) => response.json() as AccountSettings)
                   .publishReplay(1).refCount();
  }

  public saveAccountSettings(body: any): Observable<Response> {
  return this.api.put(`/me/settings`, body)
                .publishReplay(1).refCount();
  }

  public getApiKey(): Observable<ApiKey>{
    return this.api.get(`/tokens`)
                   .map((response: Response) => response.json() as ApiKey)
                   .publishReplay(1).refCount();
  }

  public createApiKey(): Observable<ApiKey>{
    return this.api.post(`/tokens`, {})
                   .map((response: Response) => response.json() as ApiKey)
                   .publishReplay(1).refCount();
  }

  public deleteApiKey(): Observable<Response> {
    return this.api.delete(`/tokens`)
                   .publishReplay(1).refCount();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/current-user.service.ts